import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/runFleetScenario';
import { fetchRequest as refreshScenarios } from '../../actions/discovery/fleetScenarios';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, shocks, topN } = action?.payload || {};
    const response = yield call(
      axios.post,
      `${config.API_URL}/goals/${goalId}/fleet/scenarios`,
      { shocks, top_n: topN },
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(response?.data?.data));
    // Show the queued scenario in the list right away; completion arrives
    // over the realtime WS (goal.fleet.scenario.completed).
    yield put(refreshScenarios({ goalId }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
